import { render, staticRenderFns } from "./timeSetting.vue?vue&type=template&id=052ae7a0&scoped=true"
import script from "./timeSetting.vue?vue&type=script&lang=js"
export * from "./timeSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052ae7a0",
  null
  
)

export default component.exports